export default {
  getBlockPriceVariations: (state) => {
    return state.blockPriceVariations
  },
}
